import React, { Component } from 'react';
import { CameraControl } from '../Controls/Camera/CameraControl.js';
import FetchService from '../../services/FetchService.js';
import AuthService from '../../services/AuthService.js'

export class IdentificacionContentPanel extends Component {
    constructor(props) {
        super(props);
        let token = AuthService.getToken();
        this.longitud = "0";
        this.latitud = "0";
        this.state = {
            token: token,
            mensaje: "Realice su marcación",
            mensajeFecha: "",
            mensajeClass: "alert alert-secondary",
            justificaciones: [],
            codigoDigitado: null,
            observaciones: null,
            identificacion: null
        }
        this.cameraControl = null;
        this.campoIdentificacion = null;
        this.campoJustificacion = null;
        this.campoObservaciones = null;
         
        this.btnEnviar_onClick = this.btnEnviar_onClick.bind(this);
        this.inputIdentificacion_onChange = this.inputIdentificacion_onChange.bind(this);
        this.inputJustificacion_onChange = this.inputJustificacion_onChange.bind(this);
        this.inputObservaciones_onChange = this.inputObservaciones_onChange.bind(this);
        this.inputIdentificacion_onKeyPress = this.inputIdentificacion_onKeyPress.bind(this);
        this.inputJustificacion_onKeyPress = this.inputJustificacion_onKeyPress.bind(this);
        this.inputObservaciones_onKeyPress = this.inputObservaciones_onKeyPress.bind(this);
    }
    componentWillMount() {
    }
    cargarJustificaciones(datos) {
        this.setState({
            justificaciones: datos
        });
    }
    cargarJustificacionesError(err) {
        alert(err);
    }
    cargarJustificacionesServidor() {
        var me = this;
        var url = 'api/Identificacion/CargarJustificacionesConCodigoAcceso';
        FetchService.send(url, 'GET', null, me.cargarJustificaciones.bind(me), me.cargarJustificacionesError.bind(me));
    }
    enviarMarcacion() {
        var me = this;
        this.getLocation(); 
    }
    getLocation() {
        if (navigator.geolocation) {
            var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };
            navigator.geolocation.getCurrentPosition(this.locationObtained.bind(this), this.enviarMarcacionConGps.bind(this),options);
        } else {
            let m = "Geolocation is not supported by this browser.";
            this.enviarMarcacionConGps();
        }
    }
    locationObtained(position) {
        this.latitud = "" + position.coords.latitude;
        this.longitud = "" + position.coords.longitude;
        this.enviarMarcacionConGps();
    }
    enviarMarcacionConGps() {
        var me = this; 
         
        var url = 'api/Identificacion/GuardarMarcacion';
        var marcacion = {}
        marcacion.usuarioId = me.state.token.id;
        marcacion.empleadoId = me.state.token.auxId;
        marcacion.tipoMarcacion = "2";
        marcacion.identificacion = me.state.identificacion;
        marcacion.codigoDigitado = me.state.codigoDigitado;
        marcacion.observaciones = me.state.observaciones;
        marcacion.foto = me.tomarFoto();
        marcacion.latitudGps = this.latitud;
        marcacion.longitudGps = this.longitud;

        if (!AuthService.getToken().auxId) {
            this.setState({
                identificacion: "",
                mensaje: "Procesando...",
                mensajeFecha: "",
                mensajeClass: "alert alert-warning"
            });
        } else {
            this.setState({
                identificacion: "",
                observaciones: "",
                mensaje: "Procesando...",
                mensajeFecha: "",
                mensajeClass: "alert alert-warning"
            });
        }

        var data = JSON.stringify(marcacion);
        FetchService.sendJson(url, 'POST', data, me.guardarMarcacion.bind(me), me.guardarMarcacionError.bind(me));
    }
    btnEnviar_onClick(event) {
        event.preventDefault();
        this.enviarMarcacion();
    }
    tomarFoto() {
        try {
            var str = this.cameraControl.takePhoto(620, 620);
            if (str) {
                str = str.substring(23);
            }
            return str;
        } catch (err) {
            return null;
        }
    }
    guardarMarcacion(datos) {
        if (datos.autorizado) {
            this.setState({
                mensaje: datos.mensaje,
                mensajeFecha: datos.fecha,
                mensajeClass: "alert alert-success"
            });
            var reset = this.resetear.bind(this);
            setTimeout(function () { reset(); }, 5000);
        }
        else {
            this.guardarMarcacionError(datos.mensaje, datos.fecha);
        }
    }
    guardarMarcacionError(err, fecha) {
        this.setState({
            mensaje: err,
            mensajeFecha: fecha,
            mensajeClass: "alert alert-danger"
        });
        var reset = this.resetear.bind(this);
        setTimeout(function () { reset(); }, 5000);
    }
    resetear() {
        this.setState({
            mensaje: "Realice su marcación",
            mensajeFecha: "",
            mensajeClass: "alert alert-secondary"
        });
    }
    componentDidMount() {
        this.cargarJustificacionesServidor();
    } 
    inputJustificacion_onChange(event) {
        this.setState({
            codigoDigitado: event.target.value
        });
    }
    inputObservaciones_onChange(event) {
        this.setState({
            observaciones: event.target.value
        });
    }
    inputIdentificacion_onChange(event) {
        this.setState({
            identificacion: event.target.value
        });
    }
    inputIdentificacion_onKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.campoJustificacion.focus();
        }
    }
    inputJustificacion_onKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.campoObservaciones.focus();
        }
    }
    inputObservaciones_onKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (this.campoIdentificacion) {
                this.campoIdentificacion.focus();
            } else {
                this.campoJustificacion.focus();
            }
            this.enviarMarcacion();
        }
    }
    crearIdentificacion() {
        if (!AuthService.getToken().auxId) {
            return (
                <div class="form-group">
                    <input ref={(input) => this.campoIdentificacion = input} type="number" placeholder="Identificación" class="form-control form-control-sm" autoFocus value={this.state.identificacion} onChange={this.inputIdentificacion_onChange} onKeyPress={this.inputIdentificacion_onKeyPress} />
                </div>
            )
        }
    }
    render() {
        return (
            <div>
                <div>
                    <div>
                        <center>
                            <div style={{ width: '20em' }}>
                                <div class="form-group" style={{ border: 'solid 1px #dddddd', backgroundColor: '#eeeeee' }}>
                                    <CameraControl ref={(input) => this.cameraControl = input} />
                                </div>
                                <div class="form-group">
                                    <div class={this.state.mensajeClass} role="alert" style={{ minHeight: '4em' }}>
                                        <center>
                                            {this.state.mensaje}
                                            <br />
                                            {this.state.mensajeFecha}
                                        </center>
                                    </div>
                                </div>
                                {this.crearIdentificacion()}
                                <div class="form-group">
                                    <select ref={(input) => this.campoJustificacion = input} class="custom-select custom-select-sm" onChange={this.inputJustificacion_onChange} onKeyPress={this.inputJustificacion_onKeyPress} >
                                        <option value="">Turno/Descanso</option>
                                        {
                                            this.state.justificaciones.map((item, index) => (
                                                <option value={item.codigo_acceso}>{item.nombre}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div class="form-group">
                                    <input ref={(input) => this.campoObservaciones = input} type="text" placeholder="Observaciones" class="form-control form-control-sm" value={this.state.observaciones} onChange={this.inputObservaciones_onChange} onKeyPress={this.inputObservaciones_onKeyPress} />
                                </div>
                                <div class="form-group">
                                    <button className="btn btn-primary btn-sm" style={{ width: '100%' }} onClick={this.btnEnviar_onClick}>Enviar</button>
                                </div>
                            </div>
                        </center>
                    </div>
                </div>
            </div>
        );
    }
}

